import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import {
  StaffCompanyDigitalPayslipRequest,
  StaffCompanyDigitalPayslipResponse,
  StaffCompanyDigitalPayslipsService,
} from "lib-klab-sdks";
import { CompanyDigitalPayslipsPort } from "../../../app/ports/organization/company-digital-payslips.port";
import {
  CompanyDigitalPayslip,
  CompanyDigitalPayslipRequest,
} from "../../../domain/models/organization/company-digital-payslip.model";

@Injectable({ providedIn: "root" })
export class CompanyDigitalPayslipsPortAdapter implements CompanyDigitalPayslipsPort {
  constructor(private readonly api: StaffCompanyDigitalPayslipsService) {}

  list(): Observable<CompanyDigitalPayslip[]> {
    return this.api.list().pipe(map((items) => items.map(mapDigitalPayslip)));
  }

  getByCompanyId(companyId: number): Observable<CompanyDigitalPayslip> {
    return this.api.getByCompanyId(companyId).pipe(map(mapDigitalPayslip));
  }

  update(
    companyId: number,
    request: CompanyDigitalPayslipRequest,
  ): Observable<CompanyDigitalPayslip> {
    return this.api
      .update(companyId, request as StaffCompanyDigitalPayslipRequest)
      .pipe(map(mapDigitalPayslip));
  }
}

function mapDigitalPayslip(
  item: StaffCompanyDigitalPayslipResponse,
): CompanyDigitalPayslip {
  return {
    id: item.companyDigitalPayslipId,
    companyId: item.companyId,
    certificateFileName: item.certificateFileName,
    certificateContentType: item.certificateContentType,
    certificateData: item.certificateData,
    digitalSignatureEnabled: item.digitalSignatureEnabled,
  };
}
